import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 28, mass: 0.25 });
  return <motion.div className="fixed inset-x-0 top-0 z-[70] h-[3px] origin-left bg-lime-300" style={{ scaleX }} aria-hidden="true" />;
};
